


































































































































































































import Element from 'element-ui'
import { Component, Vue, Watch } from 'vue-property-decorator'
import {
  UserData, emptyUser, getData, postData, putData, resetPwd
} from '@/api/systemManage/user'
import { PopUnitData } from '@/api/heritageUnit/heritageUnit'
import { getRolesByUserType } from '@/api/systemManage/role'
import { validateIntKey, validatePhone, validateCompare, validateForms, validatePwd, validateTel } from '@/configs/validate'
import { DDLItem, DefDDLItem, getCitysByUser, getInstitutes, getLookupByType, getSubTypes } from '@/api/common/select'
import { enUserType, enFirstType, enLookupType, enUserSubType } from '@/configs/enums'
import { getSubDDL, copyArray, copyDDLs } from '@/configs/functions'
// import UserModifyPwd from '@/components/systemManage/user/modifyPwd.vue'
import RspbltyInfo from './rspblty.vue'
import ExpertInfo from './expert.vue'
import PageForm from '@/components/pageLayout/form.vue'
import UnitSearchForm from '@/components/heritageUnit/search/index.vue'

import { namespace } from 'vuex-class'
const UserModule = namespace('user')
const DataSourceModule = namespace('dataSource')

const validateUnitList = (rule: any, value: any, callback: (error?: Error) => void) => {
  if (rule.formInfo.UnitList.length == 0) {
    callback(new Error('请添加文保单位'))
  } else {
    callback()
  }
}
const getFormRules = (id: number, form: { [key: string]: string | any }) => {
  return {
    UserType: [{ required: true, validator: validateIntKey('请选择用户类型'), trigger: 'change' }],
    RoleId: [{ required: true, validator: validateIntKey('请选择用户角色'), trigger: 'change' }],
    'RspbltyInfo.ResponsibilityId': [{ required: true, validator: validateIntKey('请选择责任人分类'), trigger: 'change' }],
    UnitList: [{ required: true, validator: validateUnitList, formInfo: form, trigger: 'change', message: '请添加文保单位' }],
    ApplyUnitId: [{ required: true, validator: validateIntKey('请选择评审机构'), formInfo: form, trigger: 'change' }],
    CityId: [{ required: true, validator: validateIntKey('请选择城市'), formInfo: form, trigger: 'change' }],
    CountyId: [{ required: true, validator: validateIntKey('请选择区县'), formInfo: form, trigger: 'change' }],
    TownshipId: [{ required: true, validator: validateIntKey('请选择乡镇'), formInfo: form, trigger: 'change' }],
    UserName: [
      { required: true, message: '用户名不能为空', trigger: 'blur' }
    ],
    DisplayName: [
      { required: true, message: '昵称不能为空', trigger: 'blur' }
    ],
    Email: [
      //{ required: true, message: '邮箱不能为空', trigger: 'blur' },
      { type: 'email', message: '邮箱格式不正确', trigger: 'blur' }
    ],
    Password: [
      { required: true, validator: validatePwd, trigger: 'blur' }
    ],
    ConfirmPassword: [
      { required: true, min: 8, message: '请输入确认密码' },
      { validator: validateCompare('Password', '两次输入的密码不一致', form), trigger: 'blur' }
    ],
    CellPhone: [
      { required: true, message: '手机不能为空', trigger: 'blur' },
      { validator: validatePhone, trigger: 'blur' }
    ],
    Telephone: [
      // { required: true, message: '手机不能为空', trigger: 'blur' },
      { validator: validateTel, trigger: 'blur' }
    ]
  }
}
@Component({
  components: {
    UnitSearchForm, RspbltyInfo, ExpertInfo, PageForm
  }
})
export default class UserForm extends Vue {
  @UserModule.Getter("userInfo")
  public curUser!: UserData
  get editUserType(): boolean {
    //不能修改自己的用户类型，可以修改下级
    return this.form.Id == 0 || this.form.Id !== this.curUser.Id
  }
  get showEditPwd(): boolean {
    //修改密码，只能修改自己的
    return this.form.Id > 0 && this.form.Id === this.curUser.Id
  }
  get showResetPwd(): boolean {
    //重置其他人的密码
    return this.form.Id > 0 && this.form.Id !== this.curUser.Id
  }
  /** 文保单位是否多选 */
  get unitMultiCheck(): boolean {
    return this.form.SubType != enUserSubType.GovDoc
  }
  public collapseNames = ['base']

  public firstType: number = enFirstType.Select
  public defItem: DDLItem = DefDDLItem(this.firstType)

  public emptyForm: UserData = emptyUser
  public form = Object.assign({}, this.emptyForm)
  public loading = false
  public rules = getFormRules(0, this.form)
  public userTypeList: DDLItem[] = []
  public subTypeList: DDLItem[] = []
  public roleList: DDLItem[] = [this.defItem]
  public cityList: DDLItem[] = []
  public countyList: DDLItem[] = [this.defItem]
  public townshipList: DDLItem[] = [this.defItem]
  public instituteList: DDLItem[] = []
  public responsibilityList: DDLItem[] = []
  public langList: DDLItem[] = []
  get areaLvl(): string {
    var lvl = 'city'
    var ly = this.layOut
    if (ly.showCounty) {
      lvl = 'county'
    }
    if (ly.showTownship) {
      lvl = 'township'
    }
    return lvl
  }
  // 页面布局配置
  public layOut = {
    showInstitute: false,
    showCity: false,
    showCounty: false,
    showTownship: false,
    showUnit: false,

    showRspblty: false,
    showExpert: false,
  }
  // dynamic component
  public $refs!: {
    formCtrl: PageForm
    rspbltyCtrl: RspbltyInfo
    expertCtrl: ExpertInfo
    unitSearchCtrl: UnitSearchForm
  }
  public modifyPwdDialog_Open() {
    var info = {
      userId: this.form.Id
    }
    window.eventBus.$emit('UserModifyPwd_Open', info)
  }
  public modifyPwdDialog_Close() {
  }
  public modifyPwdDialog_GetData(data: any) {

  }
  public bindEventBus() {
    window.eventBus.$on('submitUnitSearchForm', (data: PopUnitData[]) => {
      this.getUnit(data)
    })
    window.eventBus.$on('UserModifyPwd_Submit', (data: any) => {
      this.modifyPwdDialog_GetData(data)
    })
  }
  public destroyEventBus() {
    window.eventBus.$off('submitUnitSearchForm')
    window.eventBus.$off('UserModifyPwd_Submit')
  }
  public created() {
    this.fetchSource()
  }
  public mounted() {
    this.bindEventBus()
    this.fetchData()
  }
  public beforeDestroy() {
    //销毁事件，避免重复注册
    this.destroyEventBus()
  }
  //#region 弹窗查询文保单位
  public openUnitSearch() {
    window.eventBus.$emit('openUnitSearchForm')
  }
  public getUnit(data: PopUnitData[]) {
    let f = this.form
    if (!this.unitMultiCheck) {
      f.UnitList = []
    }
    data.forEach((e: any, i: number) => {
      const index: number = f.UnitList.findIndex((v: any) => v.UnitId === e.UnitId)
      if (index < 0) {
        f.UnitList.push({
          Id: 0,
          UnitId: e.UnitId,
          UnitCode: e.UnitCode,
          UnitName: e.UnitName,
          UserId: f.Id,
          NewUserId: 0,
          NewDate: new Date()
        })
      }
    })
    this.$refs.formCtrl.validateField('UnitList')
  }
  public closeUnitSearch() {
    console.log("这里是查询文保单位组件关闭后回传的事件")
  }
  public delUnit(index: number) {
    this.$confirm('确定要删除吗?', '请确认', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        this.form.UnitList.splice(index, 1)
        this.$refs.formCtrl.validateField('UnitList')
      })
      .catch(() => {
        this.$message({ type: 'info', message: '已取消操作' })
      })
  }
  //#endregion
  public modifyPwd() {
    this.modifyPwdDialog_Open()
  }
  //用到的时候延迟加载
  public setRspblty() {
    this.$nextTick(() => {
      this.$refs.rspbltyCtrl.setData(this.form.RspbltyInfo)
    })
  }
  public getRspblty() {
    this.form.RspbltyInfo = this.$refs.rspbltyCtrl.getData()
  }
  public setExpert() {
    this.$nextTick(() => {
      this.$refs.expertCtrl.setData(this.form.ExpertInfo)
    })
  }
  public getExpert() {
    this.form.ExpertInfo = this.$refs.expertCtrl.getData()
  }
  //返回多个表单验证结果
  public validResults() {
    const forms: Element.Form[] = [] // 表单列表 
    // forms.push(this.$refs.formData)
    // forms.push(this.$refs.formCtrl.getForm())
    if (this.layOut.showRspblty) {
      this.getRspblty()
      forms.push(this.$refs.rspbltyCtrl.getForm())
    }
    if (this.layOut.showExpert) {
      this.getExpert()
      forms.push(this.$refs.expertCtrl.getForm())
    }
    return validateForms(forms)
  }
  public onSubmit() {
    if (this.$refs.formCtrl.validate()) {
      this.submitData()
    }
  }
  public submitData() {
    const results = this.validResults()
    Promise.all(results).then(() => { //都通过了
      var f = this.form
      if (f.SubType == 0 && this.subTypeList.length > 0) {
        this.$message.warning('请选择子类型')
        return false
      }
      const promist =
        f.Id > 0
          ? putData(f.Id, f)
          : postData(f)
      promist.then((response: { data: any }) => {
        const data = response.data
        if (data && !data.IsError) {
          const msg = f.Id > 0 ? '保存' : '创建'
          this.$message({
            message: `用户${msg}成功`,
            type: 'success'
          })
          this.$router.back()
          //this.$router.push({ path: '/User' })
        } else {
          this.$message({
            dangerouslyUseHTMLString: true, message: `${data.Message}`, type: 'warning'
          })
          console.log(response)
        }
      })
    }).catch(() => {
      console.log("error");
      return false
    });
  }
  public resetPwd() {
    this.$confirm(`确定要重置用户密码吗?`, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      resetPwd(this.form.Id).then((response: { data: any }) => {
        const data = response.data
        if (data && !data.IsError) {
          this.$alert(`密码重置成功, 新密码为：${data.Message}`, '重置密码')
        } else {
          this.$message({
            message: '密码重置失败',
            type: 'warning'
          })
          console.log(response)
        }
      })
    }).catch(() => {
      this.$message({
        type: 'info',
        message: '已取消操作'
      })
    })
  }
  public userTypeChange() {
    const f = this.form
    if (f.UserType > 0) {
      f.UnitList = []
      this.fetchSubTypes()
      this.fetchRoles()
      this.$nextTick(() => {
        this.setLayout()
      })
    }
  }
  public subTypeChange() {
    var f = this.form
    if (f.UserType != enUserType.HeritagUnit || f.SubType == enUserSubType.GovDoc) {
      this.form.UnitList = []
    }
  }
  public setLayout() {
    const f = this.form
    const userType = f.UserType
    /*
    1省级文物局 2省财政用户 3市文物局 4市财政用户 5区县用户
    6评估机构用户 7评估专家 8文保单位用户 9巡查人员用户
    */
    //6评估机构用户 7评估专家
    const showInstitute = (userType === enUserType.ReviewInstitute || userType === enUserType.Expert)
    const showExpert = userType === enUserType.Expert
    //市级 县级
    const showCity = (userType === enUserType.CityHeritage || userType === enUserType.CityFinance || userType === enUserType.County || userType === enUserType.Township)
    const showCounty = userType === enUserType.County || userType === enUserType.Township
    const showTownship = userType === enUserType.Township
    const showRspblty = userType === enUserType.HeritagPatrol
    const showUnit = userType === enUserType.HeritagUnit
    this.layOut = {
      showInstitute: showInstitute,
      showCity: showCity,
      showCounty: showCounty,
      showTownship: showTownship,
      showUnit: showUnit,
      showRspblty: showRspblty,
      showExpert: showExpert
    }
    if (showUnit) {
      this.$refs.formCtrl.validateField('UnitList')
      this.fetchUnitSource()
    } else {
      this.$refs.formCtrl.clearValidate()
    }
    if (showInstitute) {
      this.fetchInstitutes()
    }
    if (showExpert) {
      //加载 专家相关数据源
      this.setExpert()
    }
    if (showRspblty) {
      //加载 责任主体相关数据源
      this.setRspblty()
    }
    if (!showUnit) {
      f.RspbltyInfo.ResponsibilityId = 0
      f.RspbltyInfo.Position = ''
    }
    f.ApplyUnitId = showUnit || showInstitute ? f.ApplyUnitId : 0
    f.CityId = showCity ? f.CityId : 0
    f.CountyId = showCounty ? f.CountyId : 0
    f.TownshipId = showTownship ? f.TownshipId : 0
  }
  @DataSourceModule.Getter('cityList')
  public cityCounty!: any
  @DataSourceModule.Getter('dataSource')
  public dataSource!: any
  public fetchSource() {
    var cityCounty = copyDDLs(this.cityCounty, this.firstType)
    if (cityCounty) {
      this.cityList = cityCounty
    }
    const data = Object.assign({}, this.dataSource)
    if (data) {
      this.userTypeList = data.userTypeList
      this.langList = data.langList
    }
  }
  public cityChange(reset: number) {
    this.countyList = [this.defItem]
    if (reset === 1) {
      this.form.CountyId = 0
    }
    if (this.form.CityId > 0) {
      this.countyList = getSubDDL(this.cityList, this.form.CityId, this.firstType)
    }
  }
  public countyChange(reset: number) {
    this.townshipList = [this.defItem]
    if (reset === 1) {
      this.form.TownshipId = 0
    }
    this.townshipList = [this.defItem]
    if (this.form.CountyId > 0) {
      this.townshipList = getSubDDL(this.countyList, this.form.CountyId, this.firstType)
    }
  }
  public fetchSubTypes() {
    var f = this.form
    const userType = f.UserType
    if (userType > 0) {
      getSubTypes(userType, this.firstType).then((response: { data: any }) => {
        if (response.data && +response.data.length > 0) {
          this.subTypeList = response.data
          const index = this.subTypeList.findIndex(e => e.Key === f.SubType)
          if (index < 0) {
            f.SubType = 0
            f.SubTypeName = ''
          }
        }
      })
    }
  }
  public fetchRoles() {
    var f = this.form
    const userType = f.UserType
    if (userType > 0) {
      getRolesByUserType(userType).then((response: { data: any }) => {
        if (response.data && +response.data.length > 0) {
          this.roleList = response.data
          const index = this.roleList.findIndex(e => e.Key === f.RoleId)
          if (index < 0) {
            f.RoleId = 0
            f.RoleName = ''
          }
        }
      })
    }
  }
  public fetchUnitSource() {
    // 责任人分类
    if (this.responsibilityList.length == 0) {
      getLookupByType(enLookupType.Responsibility, this.firstType).then((response: { data: any }) => {
        if (response.data && +response.data.length > 0) {
          this.responsibilityList = response.data
        }
      })
    }
  }
  public fetchInstitutes() {
    // 评审机构
    if (this.instituteList.length == 0) {
      getInstitutes(this.firstType).then((response: { data: any }) => {
        if (response.data && +response.data.length > 0) {
          this.instituteList = response.data
        }
      })
    }
  }
  public fetchUser(id: number) {
    getData(id).then((response: { data: any }) => {
      let data = response.data
      if (data) {
        if (this.doTransfer) {
          data.TransferUserId = data.Id
          data.Id = 0
        }

        this.form = data
        this.form.Password = ''
        this.form.ConfirmPassword = ''
        this.rules = getFormRules(this.form.Id, this.form)

        if (this.form.Id == 0) {
          //默认 审核通过
          this.form.Approved = true
          this.$refs.formCtrl.clearValidate()
          if (this.cityList.length == 2) {
            this.form.CityId = this.cityList[1].Key
          }
        }
        if (this.form.UserType > 0) {
          this.userTypeChange()
        }
        if (this.form.CityId > 0) {
          this.cityChange(0)
        }
        if (this.form.CountyId > 0) {
          this.countyChange(0)
        }
        this.loading = false
      }
    })
  }

  public doTransfer: boolean = false
  public fetchData() {
    const id = +this.$router.currentRoute.params.id || 0
    this.doTransfer = this.$route.path.indexOf('Transfer') > -1
    this.fetchUser(id)
  }
  public onCancel() {
    /*this.$message({
      message: 'cancel!',
      type: 'warning'
    })*/
    //这里要根据页面from来判断返回到哪个页面
    this.$router.go(-1)
    // this.$router.push({ path: '/User' })
  }
  @Watch('$route')
  public onRouteChange(route: any) {
    this.fetchData()
  }
}
